export default __webpack_public_path__ + "static/gift-card-3.url-3c9c9c9dd81876bc880947adf561d9c6.svg";